import type { Currency } from '@ps/web-core-enums';
import classNames from 'clsx';
import React, { useEffect, useState } from 'react';
import { interval as createInterval } from 'rxjs';
import { share } from 'rxjs/operators';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import type { Jackpot } from '@swf/core/types/CasinoGame';
import { integrationTesting } from '@swf/core/utils';

import styles from './JackpotRibbon.scss';

export interface Props {
  className?: string;
  currency: Currency;
  jackpot: Jackpot;
  visible: boolean;
}

export const REFRESH_RATE = 60;
export const UPDATE_RATE = 1000;
const interval = createInterval(UPDATE_RATE).pipe(share());

const JackpotRibbon: React.FC<Props> = ({ className, currency, jackpot, visible }) => {
  const [value, setValue] = useState(jackpot.value);

  useEffect(() => {
    if (integrationTesting || (!visible && value !== jackpot.value) || jackpot.value < value) {
      setValue(jackpot.value);
    }
  }, [visible, jackpot.value, value]);

  useEffect(() => {
    if (jackpot.value > value && visible) {
      let current = value;
      const increment = (jackpot.value - value) / REFRESH_RATE;
      const subscription = interval.subscribe(() => {
        current = Math.min(current + increment, jackpot.value);
        setValue(current);
      });
      return () => subscription.unsubscribe();
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jackpot.value, visible]);

  return (
    <div className={classNames(className, styles.jackpot)}>
      <CurrencyAmount {...jackpot} value={value} currency={currency} />
    </div>
  );
};

export default JackpotRibbon;
